document.addEventListener('DOMContentLoaded', function () {
  var SIZES = ['XS', 'S', 'M', 'L', 'XL'];
  var RANGES = {
    bust: [[78, 82], [83, 87], [88, 92], [93, 97], [98, 102]],
    waist: [[60, 64], [65, 69], [70, 74], [75, 79], [80, 84]],
    hip: [[86, 90], [91, 95], [96, 100], [101, 105], [106, 110]]
  };

  function bandIndex(value, ranges) {
    for (var i = 0; i < ranges.length; i++) {
      if (value <= ranges[i][1]) return i;
    }
    return ranges.length - 1;
  }

  function recommendSize(bust, waist, hip) {
    var indices = [
      bandIndex(bust, RANGES.bust),
      bandIndex(waist, RANGES.waist),
      bandIndex(hip, RANGES.hip)
    ];
    var avg = Math.round((indices[0] + indices[1] + indices[2]) / 3);
    avg = Math.max(0, Math.min(SIZES.length - 1, avg));
    return SIZES[avg];
  }

  document.querySelectorAll('[data-refyne-guide]').forEach(function (widget) {
    var submitBtn = widget.querySelector('[data-refyne-guide-submit]');
    var resultBox = widget.querySelector('[data-refyne-guide-result]');
    var sizeEl = widget.querySelector('[data-refyne-guide-size]');
    var errorEl = widget.querySelector('[data-refyne-guide-error]');

    submitBtn.addEventListener('click', function () {
      var bust = parseFloat(widget.querySelector('[data-refyne-bust]').value);
      var waist = parseFloat(widget.querySelector('[data-refyne-waist]').value);
      var hip = parseFloat(widget.querySelector('[data-refyne-hip]').value);

      if (!bust || !waist || !hip) {
        errorEl.hidden = false;
        resultBox.hidden = true;
        return;
      }

      errorEl.hidden = true;
      var size = recommendSize(bust, waist, hip);
      sizeEl.textContent = size;
      resultBox.hidden = false;
    });
  });
});
